import { FullGridWidthDiv } from '@dreamstack/feature-components/src/layout/MainGrid'
import { assertPopulatedDeep } from '@dreamstack/payload/src/lib/assertPopulated'
import type { BlockFullsizeImage } from '@dreamstack/payload/src/payload-types'
import Image from 'next/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import React from 'react'

export const FullsizeImage: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockFullsizeImage
  }>
> = ({ block }) => {
  assertPopulatedDeep(block)
  const image = block?.image
  if (!image?.url) return null
  const downloadFile = block?.downloadFile
  const downloadHref = downloadFile?.url
  const Wrapper = block?.maxWidthParent ? React.Fragment : FullGridWidthDiv
  const ImageElement = (
    <Image
      src={image.url}
      width={image.width ?? undefined}
      height={image.height ?? undefined}
      alt={image.alt ?? ''}
      quality={100}
      style={{ width: '100%', height: 'auto' }}
    />
  )
  return (
    <Wrapper>
      {!!downloadHref ? (
        <Link href={downloadHref} passHref target="_blank">
          {ImageElement}
        </Link>
      ) : (
        ImageElement
      )}
    </Wrapper>
  )
}
